import BaseListPage from "../../../../../base/BaseListPage";
import withRouter from "../../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import createPromise from "../../../../../utils/createPromise";
import dialog from "../../../../../components/Modal/dialog";
// import ChooseCreditActionModal from "./components/ChooseCreditActionModal";
import DialogCredit from "./components/DialogCredit";
import CreditInActiveListPresenter from "./CreditInActiveListPresenter";

class CreditInActiveListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CreditInActiveListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );
    this.state = {
      objects: [],
      credit: {},
      client: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
    };

    this.fieldsToDisplay = ["name", "credit", "status"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "credits";
  }

  onClickDeleteItem(index) {
    this.presenter.onClickDeleteItem(index);
  }

  onClickViewCreditModal(index) {
    this.presenter.onClickViewCreditModal(index);
  }

  onCreditChange(value, field) {
    const object = this.state.credit;
    object[field] = value;
    this.setCredit(object);
  }

  setCredit(credit) {
    this.setState({ credit });
  }

  onClickViewSearchLogs(index) {
    const objectID = this.state.objects[index]?.code;
    this.navigateTo(`search-logs/${objectID}`);
  }

  onClickLogs(object) {
    this.navigateTo(`/user/credit-logs/${object.id}`);
  }

  onClickInactive(object) {
    this.presenter.onClickInactive(object);
  }

  getActions() {
    return [
      {
        label: "Edit",
        onClick: (index) => {
          const object = this.state.objects[index];
          this.onClickAdd(object); // pass the actual object
        },
        icon: "bi bi-pencil-square",
      },
      {
        label: "View Logs",
        onClick: (index) => {
          const object = this.state.objects[index];
          this.onClickLogs(object); // pass the actual object
        },
        icon: "bi bi-eye",
      },
      {
        label: "Active",
        onClick: (index) => {
          const object = this.state.objects[index];
          this.onClickInactive(object); // pass the actual object
        },
        icon: "bi bi-arrow-down-up",
      },
    ];
  }

  formatFields(fields) {
    const { firstName, middleName, lastName, status, ...rest } = fields;

    return {
      ...rest,
      name: { type: "String", label: "Client Name" },
      credit: { type: "String", label: "Credit" },
      status: { type: "String", label: "Status" },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      const { ...rest } = object || {};

      return {
        ...rest,
        name: object?.client?.name,
        credit: object?.balance || 0,
        status: object?.status,
      };
    });
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  onSubmit() {
    this.presenter.submitData();
    dialog.close();
  }

  //   onClickAdd() {
  //     const { client } = this.state;
  //     // this.presenter.onClickAdd();
  //     const schema = this.getSchema(this.getCollectionName());
  //     dialog.fire({
  //       html: (
  //         <DialogCredit
  //           onChange={this.onChange.bind(this)}
  //           schema={schema}
  //           client={client}
  //           onSubmit={this.onSubmit.bind(this)}
  //         />
  //       ),
  //       footer: false,
  //     });
  //   }
  onClickAdd(object = null) {
    const { client } = this.state;
    const schema = this.getSchema(this.getCollectionName());

    // Guard: if "object" is actually an event, ignore it
    if (object?.target) {
      return; // it's a click event, not a valid object
    }

    if (object) {
      this.presenter.object = object;
      this.presenter.change = { ...object };
    } else {
      this.presenter.object = {};
      this.presenter.change = {};
    }

    dialog.fire({
      html: (
        <DialogCredit
          onChange={this.onChange.bind(this)}
          schema={schema}
          client={client}
          onSubmit={this.onSubmit.bind(this)}
          initialValues={object}
        />
      ),
      footer: false,
    });
  }

  setClient(response) {
    this.setState({ client: response });
  }

  getAcl() {
    const roles = this.getCurrentRoles();
    const aclRoles = roles.map((r) => `role:${r.id}`);
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id, ...aclRoles],
      write: ["*", user.id, ...aclRoles],
    };
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    console.log("objects", objects);

    return (
      <PageContainer
        title="Credit Top-Up"
        // buttonHandler={this.onClickAdd.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="row">
          <Search
            schemas={this.getSchemas()}
            className="w-50"
            onSubmit={this.searchSubmit.bind(this)}
            fields={schema.fields}
          />
          <button
            className="btn btn-primary w-25"
            onClick={() => this.navigateBack()}
          >
            Back to Active Credit
          </button>
        </div>
        <Table
          fields={this.formatFields(schema.fields)}
          objects={this.formatObjects(objects)}
          collapsable
          progress={loading}
          actions={this.getActions.bind(this)}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(CreditInActiveListPage);
